<div id="outer" class="well container">
    <div class="well-title">
        <div class="col-md-12">{{ getTab(tab)?.name }}</div>
    </div>
    <div class="col-md-12 well-content">
        <ul class="nav nav-tabs">
            @for (curTab of tabs; track curTab) {
                <li [ngClass]="getClass(curTab.tab)" style="cursor: pointer" role="presentation">
                    <a (click)="tab = curTab.tab"><span [innerText]="curTab.name"></span></a>
                </li>
            }
        </ul>
        <div
            [ngStyle]="{
                display: tab === 'two-factor' ? 'flex' : 'block'
            }"
            style="justify-content: center; width: 100%; margin-top: 15px">
            @switch (tab) {
                @case ("info") {
                    <app-user-info></app-user-info>
                }
                @case ("email") {
                    <app-change-email></app-change-email>
                }
                @case ("password") {
                    <app-change-password></app-change-password>
                }
                @case ("two-factor") {
                    <app-two-factor></app-two-factor>
                }
                @case ("logout") {
                    <app-logout></app-logout>
                }
            }
        </div>
    </div>
</div>
